<script setup lang="ts">
import { AtomIcon, AtomButton } from "@chatfood/design-system";
import { bemBuilder } from "@chatfood/core-utils";
import { useCustomerStore } from "~/stores/customer";

const css = bemBuilder("loyalty-balance-button");

const props = withDefaults(
  defineProps<{
    viewOnly?: boolean;
  }>(),
  {
    viewOnly: false,
  },
);

const emits = defineEmits<{
  click: [event: MouseEvent];
}>();

const customer = useCustomerStore();
</script>

<template>
  <div
    :class="[
      css(''),
      {
        [css('', 'view-only')]: props.viewOnly,
      },
    ]"
  >
    <AtomButton
      :class="css('cta')"
      theme="ghost"
      variant="primary"
      @click="emits('click', $event)"
    >
      <AtomIcon name="rating-ghost" ignore-color />
      <span>{{ customer.loyalty.balance }}</span>
    </AtomButton>
  </div>
</template>

<style lang="scss" scoped>
.loyalty-balance-button {
  $self: &;

  &__cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-sm);
  }

  &--view-only {
    #{$self}__cta {
      cursor: default;
      pointer-events: none;
    }
  }
}
</style>
